import { Component, ReactNode, ErrorInfo } from 'react';
import { Button } from 'react-bootstrap';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {  
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ error, errorInfo });
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-1 mx-sm-5 mt-4">
          <h3>Something went wrong!</h3>
          <p>Please refresh the page and try again.</p>
          {this.state.error && (<p>{this.state.error.toString()}</p>)}
          {this.state.errorInfo && (
            <details className="mb-4">
              <summary>View additional error information</summary>
              <pre>{this.state.errorInfo.componentStack}</pre>
            </details>
          )}
          <Button variant="primary" onClick={() => window.location.reload()}>Refresh Page</Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;